import React from 'react';
import { get, find, merge } from 'lodash';

// React view component to render
import { cSrOrderNotes as CSrOrderNotesView } from 'ui/views/widgets/cSROrderNotes';
import { CsrOrderNotesService } from 'services/csrOrderNotes';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as pageLevelPreloader from 'modules/page-level-preloader';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CsrOrderNotes } from 'ui/containers/CsrOrderNotes';
 *
 * // render
 * <CsrOrderNotes propName='propValue'/>
 */
export class CsrOrderNotes extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        
        this.state = {
            items: get( this.props, 'data.items', [] ),
            enableAdd: false
        };

        // create service instance
        this.csrOrderNotesService = new CsrOrderNotesService();

        this.handleAddClick = this.handleAddClick.bind( this );
        this.handleAddNote = this.handleAddNote.bind( this );
    }

    handleAddClick( val ) {
        log.debug( 'CsrOrderNotes.handleAddClick()' );
        this.setState( { enableAdd: val } );
    }

    async handleAddNote( value ) {
        log.debug( 'CsrOrderNotes.handleAddNote()' );

        pageLevelPreloader.show();

        // cancel ongoing request
        this.csrOrderNotesService.cancel();

        const action = find( this.props.data.formActions, { name: 'save' } );

        const reqData =  merge(
            { ...this.props.requestPayload },
            {
                data: { note: get( value, 'description' ), type: get( value, 'type' ), orderId: get( this.props, 'orderId' ) }
            },
        );

        // fetch component data
        const { status } = await this.csrOrderNotesService.submitAddNote( {
            url: get( action, 'url' ),
            data: reqData
        } );
        
        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {

                pageLevelPreloader.hide();
				errorOverlay.open();
            
        } else {
            this.fetchNotes();
        }
    }


    async fetchNotes() {
        log.debug( 'CsrOrderNotes.fetchNotes()' );

         // cancel ongoing request
         this.csrOrderNotesService.cancel();

         // get status and service data
        const { status, data } = await this.csrOrderNotesService.fetchOrderNotes( {
            url: this.props.url,
            data: this.props.requestPayload
        } );

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

            this.setState( {
                items: get( data, 'items' ),
                enableAdd: false
            }, () => {

                pageLevelPreloader.hide();

            } );
        } else {
            pageLevelPreloader.hide();
            errorOverlay.open();
        }
    }

    componentWillUnmount() {
        this.csrOrderNotesService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CSrOrderNotesView
                { ...this.props }
                { ...this.state }
                onClickAdd = { this.handleAddClick }
                onSubmitClick={ this.handleAddNote }
            />
        );
    }
}

// set display name
CsrOrderNotes.displayName = 'CsrOrderNotes';

// set default props
CsrOrderNotes.defaultProps = {};

// prop types
CsrOrderNotes.propTypes = {};
